import React from 'react';
import { Info, Check, Crown, Sparkles } from 'lucide-react';
import { colors, typography, spacing, radius } from '../../styles/theme';

const SignupTierInfo = () => {
  return (
    <div style={{
      background: 'rgba(59, 130, 246, 0.12)',
      backdropFilter: 'blur(10px)',
      border: `1px solid rgba(59, 130, 246, 0.35)`,
      borderRadius: '16px',
      padding: '1.5rem',
      fontFamily: typography.fontSans,
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing[2],
        marginBottom: spacing[4]
      }}>
        <div style={{
          background: 'rgba(59, 130, 246, 0.2)',
          borderRadius: radius.full,
          padding: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Info size={16} color={colors.primary} />
        </div>
        <span style={{
          fontSize: typography.base,
          fontWeight: typography.bold,
          color: '#e2e8f0',
          letterSpacing: '0.01em'
        }}>
          What's Included in Free Tier:
        </span>
      </div>
      
      <div style={{
        display: 'grid',
        gap: spacing[3],
        marginBottom: spacing[4]
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing[3],
          fontSize: typography.sm,
          color: '#cbd5e1'
        }}>
          <div style={{
            background: 'rgba(16, 185, 129, 0.15)',
            borderRadius: radius.full,
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <Check size={14} color={colors.success} strokeWidth={3} />
          </div>
          <span><strong style={{ color: '#e2e8f0' }}>8 rounds per day</strong> — Perfect for daily practice</span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing[3],
          fontSize: typography.sm,
          color: '#cbd5e1'
        }}>
          <div style={{
            background: 'rgba(16, 185, 129, 0.15)',
            borderRadius: radius.full,
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <Check size={14} color={colors.success} strokeWidth={3} />
          </div>
          <span><strong style={{ color: '#e2e8f0' }}>Track progress</strong> for 30 days</span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing[3],
          fontSize: typography.sm,
          color: '#cbd5e1'
        }}>
          <div style={{
            background: 'rgba(16, 185, 129, 0.15)',
            borderRadius: radius.full,
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <Check size={14} color={colors.success} strokeWidth={3} />
          </div>
          <span><strong style={{ color: '#e2e8f0' }}>3 training dimensions</strong> available</span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing[3],
          fontSize: typography.sm,
          color: '#cbd5e1'
        }}>
          <div style={{
            background: 'rgba(16, 185, 129, 0.15)',
            borderRadius: radius.full,
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <Check size={14} color={colors.success} strokeWidth={3} />
          </div>
          <span><strong style={{ color: '#e2e8f0' }}>Save 3 favorite</strong> configurations</span>
        </div>
      </div>
      
      <div style={{
        background: 'rgba(251, 191, 36, 0.1)',
        border: '1px solid rgba(251, 191, 36, 0.25)',
        borderRadius: '10px',
        padding: '0.75rem 1rem',
        fontSize: typography.sm,
        color: '#fbbf24',
        display: 'flex',
        alignItems: 'center',
        gap: spacing[2],
        fontWeight: typography.semibold
      }}>
        <Sparkles size={16} color={colors.warning} />
        <span>Want unlimited? Upgrade to Pro anytime after signup</span>
      </div>
    </div>
  );
};

export default SignupTierInfo;

